import React, { useState, useEffect, useRef } from "react";
import FlatButton from "material-ui/FlatButton";
import Menu from "material-ui/Menu";
import MenuItem from "material-ui/MenuItem";
import { primaryColor, secondaryColor, disabledColor } from "../../theme";
import { pick, omit } from "lodash";
import HelpTooltip from "../../agenda/Cro/components/HelpTooltip";

const DropdownButton = ({ helpEnum, helpWidth, tooltipPosition, options = [], ...props }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  const handleClick = () => setOpen((prev) => !prev);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  const mergedStyle = {
    borderRadius: 6,
    height: 36,
    lineHeight: "36px",
    minWidth: 96,
    textTransform: "none",
    fontWeight: 700,
    ...props.style,
  };

  const menuStyle = {
    position: "absolute",
    background: "white",
    display: open ? "block" : "none",
    minWidth: "min-content",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    borderRadius: 4,
    zIndex: 1000,
    marginTop: 4,
    padding: 0,
  };

  const button = (
    <FlatButton
      {...props}
      onClick={handleClick}
      backgroundColor={props.disabled ? disabledColor : primaryColor}
      hoverColor={secondaryColor}
      style={mergedStyle}
    />
  );

  const menu = (
    <Menu style={menuStyle} autoWidth={true}>
      {options.map((option, idx) => (
        <MenuItem
          key={idx}
          primaryText={option.label}
          onClick={() => {
            setOpen(false);
            if (option.onClick) option.onClick();
          }}
          disabled={option.disabled}
        />
      ))}
    </Menu>
  );

  if (helpEnum) {
    return (
      <div style={pick(mergedStyle, [
        "margin",
        "marginTop",
        "marginRight",
        "marginBottom",
        "marginLeft",
      ])}>
        <HelpTooltip
          helpEnum={helpEnum}
          style={{ width: helpWidth }}
          tooltipPosition={tooltipPosition}
        >
          <div ref={wrapperRef} style={{ position: 'relative', display: 'inline-block' }}>
            {button}
            {options && options.length > 0 && menu}
          </div>
        </HelpTooltip>
      </div>
    );
  }

  return (
    <div ref={wrapperRef} style={{ position: 'relative', display: 'inline-block' }}>
      {button}
      {options && options.length > 0 && menu}
    </div>
  );
};

export default DropdownButton;
